import { dateUtils } from '../common'

const NATION_CODE = Symbol('NATION_CODE') //              国家代码
const ENTERPRISE_CODE = Symbol('ENTERPRISE_CODE') //      企业代码
const PRODUCT_IDENT = Symbol('PRODUCT_IDENT') //          产品标识
const PRODUCT_CODE = Symbol('PRODUCT_CODE') //            产品代码
const BATCHNUMBER = Symbol('BATCHNUMBER') //              批号
const SERIAL_NUMBER = Symbol('SERIAL_NUMBER') //          原厂序列号
const PERIOD_BEGIN = Symbol('PERIOD_BEGIN') //            生产日期
const PERIOD_EXPIRE = Symbol('PERIOD_EXPIRE') //          失效日期
const PERIOD_END = Symbol('PERIOD_END') //                有效期
// const CHECK_CODE = Symbol('CHECK_CODE'); //                校验位

// 正则
const regs = {}
regs[NATION_CODE] = /(?<=^MA\.)\d{3}?/
regs[ENTERPRISE_CODE] = /(?<=M\d.)\d+(?=\.)/
regs[PRODUCT_IDENT] = /^MA\S{8}.*?(?=(\.[A-Z]|$))/
regs[BATCHNUMBER] = /(?<=\.L).+?(?=(\.|$))/
regs[SERIAL_NUMBER] = /(?<=\.S).+?(?=(\.|$))/
regs[PERIOD_BEGIN] = /(?<=\.P).+?(?=(\.|$))/
regs[PERIOD_EXPIRE] = /(?<=\.E).+?(?=(\.|$))/
regs[PERIOD_END] = /(?<=\.V).+?(?=(\.|$))/
// regs[CHECK_CODE] = /(?<=\.C).+?(?=(\.|$))/;

/**
 * 解析 MA 码类
 *
 * @class AnalysisMaCode
 * @param {string} [code=""] 待解析 MA 码
 *
 */
export default class AnalysisMaCode {
  constructor(code = '') {
    if (!/^(MA\.|MA1(\.)|MAIN\.|MA(L|S|P|E|V)\.)/i.test(code))
      throw new Error('请输入正确的 MA 码！')
    if (!this.m) this.m = new Map()

    // 待解析的 MA 码
    this.code = this.preprocess(code)
    //
    this.analysis()
  }

  // 预处理待解析 code
  preprocess(code) {
    console.log('待预处理 code: ', code)
    const _code = `${code}`.toUpperCase() //                               优化#31648，否则按大写键后可能无法识别
    const c = _code
      .replace(/MA1(\.){1,}(L|S|P|E|V|M)/, '.$2') //                       替换 MA1.X -> .X
      .replace(/MAIN\./, '.') //                                           替换 MAIN.XXX -> .XXX
      .replace(/MA(L|S|P|E|V)\./g, '.$1') //                              替换 MAX. -> .X

    const pi = c.match(regs[PRODUCT_IDENT])
    const p = pi ? pi[0] : '' //                                          产品标识段
    const o = c.replace(regs[PRODUCT_IDENT], '').replace(/\.M/, '.P') //  截取非产品标识段并转换 .M -> .P
    console.log('预处理后 code: ', p + o)
    return p + o
  }

  // 解析
  analysis() {
    this.analysisNationCode()
    this.analysisEnterpriseCode()
    this.analysisProductCode()
    this.analysisCode(BATCHNUMBER)
    this.analysisCode(SERIAL_NUMBER)
    this.analysisCode(PERIOD_BEGIN)
    this.analysisCode(PERIOD_EXPIRE)
    this.analysisCode(PERIOD_END)
  }

  /* 解析 */
  // 解析国家代码
  analysisNationCode() {
    const ret = this.code.match(regs[NATION_CODE])
    this.m.set(NATION_CODE, ret ? ret[0] : '')
  }

  // 解析企业代码
  analysisEnterpriseCode() {
    const ret = this.code.match(regs[ENTERPRISE_CODE])
    this.m.set(ENTERPRISE_CODE, ret ? ret[0] : '')
  }

  // 解析产品标识和产品代码
  analysisProductCode() {
    const ret = this.code.match(regs[PRODUCT_IDENT])
    const str = ret ? ret[0] : ''
    const start = str.lastIndexOf('.') + 2
    const end = start + 6
    this.m.set(PRODUCT_IDENT, str) // 产品标识
    this.m.set(PRODUCT_CODE, str.substring(start, end)) // 产品代码
  }

  // 解析批号、原厂序列号、生产日期、失效日期和有效期
  analysisCode(code = BATCHNUMBER) {
    const tmp = this.code.match(regs[code])
    let ret = tmp ? tmp[0] : ''
    // 生产日期、失效日期和有效期格式化
    const codes = [PERIOD_BEGIN, PERIOD_EXPIRE, PERIOD_END]
    if (ret && codes.includes(code)) {
      ret = dateUtils.formatMaDate(ret)
    }
    this.m.set(code, ret)
  }

  // 返回 Map
  map() {
    return {
      nationCode: { label: '国家代码', value: this.m.get(NATION_CODE) || null },
      enterpriseCode: { label: '企业代码', value: this.m.get(ENTERPRISE_CODE) || null },
      productIdent: { label: '产品标识', value: this.m.get(PRODUCT_IDENT) || null },
      productCode: { label: '产品代码', value: this.m.get(PRODUCT_CODE) || null },
      batchNumber: { label: '批号', value: this.m.get(BATCHNUMBER) || null },
      serialNumber: { label: '原厂序列号', value: this.m.get(SERIAL_NUMBER) || null },
      periodBegin: { label: '生产日期', value: this.m.get(PERIOD_BEGIN) || null },
      periodExpire: { label: '失效日期', value: this.m.get(PERIOD_EXPIRE) || null },
      periodEnd: { label: '有效期', value: this.m.get(PERIOD_END) || null },
    }
  }
}
